import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type ForwardingLocation = {
  forwarding_location_id?: number; // 출고지 idx
  delivery_charge?: number; // 배송비
  forwarding_name?: string; // 출고 그룹명
  forwarding_address?: string; // 출고지 주소
  forwarding_address_detail?: string; // 출고지 상세주소
  return_price?: number; // 반품 배송비(편도)
  exchange_price?: number; // 교환배송비(왕복)
  phone?: string; // 연락처
  delivery_company?: string; // 택배사
  delivery_method?: string; // 배송방법
  return_address?: string; // 반품/교환지 주소
  return_address_detail?: string; // 반품/교환지 상세주소
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] ForwardingLocation
   * --
   */
  getForwardingLocations: async (params?: {
    [key: string]: string | number;
  }) => {
    try {
      const res = await $http.get(APIConstant.GETS_FORWARDING_LOCATION, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] ForwardingLocation
   * --
   */
  getForwardingLocation: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_FORWARDING_LOCATION, {
        forwarding_location_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] ForwardingLocation
   * --
   */
  createForwardingLocation: async (body: ForwardingLocation) => {
    try {
      const res = await $http.post(
        APIConstant.CREATE_FORWARDING_LOCATION,
        body
      );

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] ForwardingLocation
   * --
   */
  updateForwardingLocation: async (body: ForwardingLocation) => {
    try {
      const { forwarding_location_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_FORWARDING_LOCATION, {
        forwarding_location_id: forwarding_location_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] ForwardingLocation
   * --
   */
  deleteForwardingLocation: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_FORWARDING_LOCATION, {
        forwarding_location_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
